import { config } from "config";
import { SetDeliveryCarCategoriesPayload, DeliveryCarCategoryState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;
const initialState: DeliveryCarCategoryState = {
  totalCount: 0,
  deliveryCarCategories: [],
  deliveryCarCategory: null,
  loading: true,
  refresh: 0,
  refreshLoader: false,
  deliveryCarCategoryOptions: [],
  current_filters: {},
  filters: { page: 1, pageSize: default_page_size },
};

export const deliveryCarCategorySlice = createSlice({
  name: "deliveryCarCategory",
  initialState,
  reducers: {
    clear: (state) => {
      state.deliveryCarCategoryOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addCarCategory: (state, action) => {
      state.deliveryCarCategories.unshift(action.payload);
    },
    updateCarCategory: (state, action) => {
      const { id, category } = action.payload;
      state.deliveryCarCategories.every(({ _id }, i) => {
        if (id === _id) {
          state.deliveryCarCategories[i] = category;
          return false;
        }
        return true;
      });
    },
    deleteCarCategoryById: (state, action) => {
      const id = action.payload;
      state.deliveryCarCategories.every(({ _id }, i) => {
        if (id === _id) {
          state.totalCount -= 1;
          state.deliveryCarCategories.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setCarCategory: (state, action) => {
      state.deliveryCarCategory = action.payload;
    },
    setCarCategories: (
      state,
      action: PayloadAction<SetDeliveryCarCategoriesPayload>
    ) => {
      const { totalCount, deliveryCarCategories } = action.payload;

      state.totalCount = totalCount;
      state.deliveryCarCategories = deliveryCarCategories;
    },
    setPage: (state, action: PayloadAction<{ page: number }>) => {
      const { page } = action.payload;
      state.filters.page = page;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setCarCategoryOptions: (state, action) => {
      state.deliveryCarCategoryOptions = action.payload;
    },
  },
});

const deliveryCarCategoryReducer = deliveryCarCategorySlice.reducer;

export const deliveryCarCategoryActions = deliveryCarCategorySlice.actions;
export default deliveryCarCategoryReducer;
